module.exports = __webpack_public_path__ + "61d6bab4e5b81da43e1f87d1cc25b3cf.MP3";